import { Values } from 'components/commonTypes';

export const EstimateAmplitudeFlagKeys = {
  estimatesFranchiseReporting: 'estimates-franchise-reporting',
  estimatesExpirationDate: 'estimates-expiration-date',
  estimatesExpirationDateSettings: 'estimates-expiration-date-settings',
  estimatesEnhancedPresentationMode: 'estimates-enhanced-presentation-mode',
  estimatesTemplates: 'estimates-templates',
  estimatesServiceDate: 'estimates-service-date',
  estimatesCropImages: 'estimates-crop-images',
} as const;

export type EstimateAmplitudeFlagType = Values<typeof EstimateAmplitudeFlagKeys>;

export const TruthyValuesForEstimateFlagKeys: Record<EstimateAmplitudeFlagType, string> = {
  [EstimateAmplitudeFlagKeys.estimatesFranchiseReporting]: 'using-estimates-franchise-reporting',
  [EstimateAmplitudeFlagKeys.estimatesExpirationDate]: 'using-estimates-expiration-date',
  [EstimateAmplitudeFlagKeys.estimatesExpirationDateSettings]: 'using-estimates-expiration-date-settings',
  [EstimateAmplitudeFlagKeys.estimatesEnhancedPresentationMode]: 'using-estimates-enhanced-presentation-mode',
  [EstimateAmplitudeFlagKeys.estimatesTemplates]: 'using-estimates-templates',
  [EstimateAmplitudeFlagKeys.estimatesServiceDate]: 'using-estimates-service-date',
  [EstimateAmplitudeFlagKeys.estimatesCropImages]: 'using-estimates-crop-images',
} as const;
